import { IUserSecurityPhone } from "@/common/api/unifiedPortal/interfaces";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useSecurityPhoneStore = defineStore("securityPhone", () => {
  const securityPhone = ref<IUserSecurityPhone | null>(null);
  return {
    securityPhone,
  };
});
